import React from "react";
import { StyledLabel, StyledSelectInput } from "@aureskonnect/react-ui";
import classnames from "classnames";
import { AvGroup, AvField } from "availity-reactstrap-validation";
import { useTranslation } from "react-i18next";
import { ipMatchWord } from "@constants/index";

import { useMoneticsForm } from "./MoneticsFormContext";
import { NEPTING_REFERENCE_OPTIONS } from "./moneticsConstants";
import { FieldError } from "./components/FieldError";

export function NeptingConfig() {
    const { form, props } = useMoneticsForm();
    const {
        port,
        setPort,
        setIpAddress,
        ipAddress,
        InputPort,
        setInputPort,
        numberMatchWord,
        InputCode,
        setMerchantCode,
        setInputCode,
        merchantCode,
        paymentType,
        SelectInput,
        paramsTypes,
        setSelectInput,
        setPaymentType,
        InputUrl,
        setUrl,
        setInputUrl,
        url,
        inputSetupType,
        typeConfig,
        setTypeConfig,
        typeOfConfig,
        setInputSetupType,
        inputTerminalType,
        typeTerminal,
        typeOfTerminal,
        setTypeTerminal,
        setInputTerminalType,
        setReference,
        reference,
    } = form;
    const { isConsult, setIsEdited, InputIp, ipExist, setInputIp } = props;
    const { t } = useTranslation();
    const neptingReferencesArray: {
        label: string;
        value: string;
    }[] = NEPTING_REFERENCE_OPTIONS.map((element: string) => {
        return {
            label: element,
            value: element,
        };
    });
    return (
        <React.Fragment>
            <AvGroup>
                <StyledLabel htmlFor="text" className="mt-3">
                    {t("Reference")}
                </StyledLabel>

                <StyledSelectInput
                    data-testid="monetics-nepting-reference-select"
                    className={classnames("mnt_inp_reference", {
                        readOnly__clz: isConsult,
                    })}
                    onChange={(e: any) => {
                        setReference(e.value);
                        setIsEdited(true);
                    }}
                    value={
                        reference === ""
                            ? null
                            : {
                                  label: reference,
                                  value: reference,
                              }
                    }
                    options={neptingReferencesArray}
                    name="reference"
                    placeholder={t("Select")}
                    noOptionsMessage={() => t("No options")}
                />
            </AvGroup>
            <AvGroup>
                <StyledLabel className="mt-3 required__clz" htmlFor="text">
                    {t("IP address")}
                </StyledLabel>
                <AvField
                    data-testid="monetics-nepting-ip-input"
                    className={classnames("mnt_inp_ipAdress", {
                        input__clz: InputIp || ipExist,
                        readOnly__clz: isConsult,
                    })}
                    autocomplete="off"
                    id="ip"
                    name="ip"
                    placeholder={t("Write")}
                    type="text"
                    onChange={(e: any) => {
                        setIpAddress(e.target.value);
                        if (
                            !e.target.value.match(ipMatchWord) &&
                            e.target.value !== ""
                        ) {
                            setInputIp(true);
                        } else {
                            setInputIp(false);
                        }
                        setIsEdited(true);
                    }}
                    value={ipAddress}
                />
                {InputIp || ipExist ? (
                    <FieldError>
                        {
                            t(
                                ipAddress === ""
                                    ? "Please enter a IP address"
                                    : !ipAddress.match(ipMatchWord)
                                    ? "IP address is invalid"
                                    : "The ip address is already exists"
                            )!
                        }
                    </FieldError>
                ) : null}
            </AvGroup>
            <AvGroup>
                <StyledLabel className="mt-3 required__clz" htmlFor="text">
                    {t("Port number")}
                </StyledLabel>
                <AvField
                    data-testid="monetics-nepting-port-input"
                    className={classnames("mnt_inp_portNumber", {
                        input__clz: InputPort,
                        readOnly__clz: isConsult,
                    })}
                    autocomplete="off"
                    id="port-number"
                    name="port-number"
                    placeholder={t("Write")}
                    type="text"
                    onChange={(e: any) => {
                        setPort(e.target.value);
                        setInputPort(false);
                        setIsEdited(true);
                    }}
                    value={port}
                    validate={{
                        pattern: {
                            value: numberMatchWord,
                            errorMessage: t("Port number is invalid"),
                        },
                    }}
                />
                {InputPort && (
                    <FieldError>
                        {t("Please enter a port number")}
                    </FieldError>
                )}
            </AvGroup>
            <AvGroup>
                <StyledLabel className="mt-3 required__clz" htmlFor="text">
                    {t("Merchant code")}
                </StyledLabel>
                <AvField
                    data-testid="monetics-nepting-merchant-code-input"
                    className={classnames("mnt_inp_workingCode", {
                        input__clz: InputCode,
                        readOnly__clz: isConsult,
                    })}
                    autocomplete="off"
                    id="merchantCode"
                    name="merchantCode"
                    placeholder={t("Write")}
                    type="text"
                    onChange={(e: any) => {
                        setMerchantCode(e.target.value);
                        setInputCode(false);
                        setIsEdited(true);
                    }}
                    value={merchantCode}
                />
                {InputCode && (
                    <FieldError>
                        {t("Please enter a merchant code")}
                    </FieldError>
                )}
            </AvGroup>
            <AvGroup>
                <StyledLabel className="mt-3 required__clz" htmlFor="text">
                    {t("Mode of payment")}
                </StyledLabel>

                <StyledSelectInput
                    value={
                        paymentType === ""
                            ? null
                            : {
                                  label: paymentType,
                                  value: paymentType,
                              }
                    }
                    className={classnames(
                        "mnt_inp_typeOfPayment",

                        {
                            invalid__clz: SelectInput,
                            readOnly__clz: isConsult,
                        }
                    )}
                    name="paymentType"
                    options={paramsTypes}
                    onChange={(e: any) => {
                        setSelectInput(false);
                        setPaymentType(e.value);
                        setIsEdited(true);
                    }}
                    placeholder={t("Select")}
                    noOptionsMessage={() => t("No options")}
                />

                {SelectInput && (
                    <FieldError>
                        {t("Please select a mode of payement")}
                    </FieldError>
                )}
            </AvGroup>
            <AvGroup>
                <StyledLabel className="mt-3 required__clz" htmlFor="text">
                    {t("URL")}
                </StyledLabel>
                <AvField
                    data-testid="monetics-nepting-url-input"
                    className={classnames("mnt_inp_url", {
                        input__clz: InputUrl,
                        readOnly__clz: isConsult,
                    })}
                    autocomplete="off"
                    id="url"
                    name="url"
                    placeholder={t("Write")}
                    type="text"
                    onChange={(e: any) => {
                        setUrl(e.target.value);
                        setInputUrl(false);
                        setIsEdited(true);
                    }}
                    value={url}
                />
                {InputUrl && (
                    <FieldError>
                        {t("Please enter a URL")}
                    </FieldError>
                )}
            </AvGroup>
            <AvGroup>
                <StyledLabel className="mt-3 required__clz" htmlFor="text">
                    {t("Setup Type")}
                </StyledLabel>
                <StyledSelectInput
                    data-testid="monetics-nepting-setup-type-select"
                    className={classnames("mnt_drp_setupType", {
                        invalid__clz: inputSetupType,
                        readOnly__clz: isConsult,
                    })}
                    value={
                        Object.keys(typeConfig).length > 0 ? typeConfig : null
                    }
                    id="setupType"
                    name="setupType"
                    options={typeOfConfig}
                    onChange={(e: any) => {
                        if (e !== null) {
                            setTypeConfig(e);
                            setInputSetupType(false);
                        } else {
                            setInputSetupType(true);
                        }
                        setIsEdited(true);
                    }}
                    placeholder={t("Select")}
                    noOptionsMessage={() => t("No options")}
                    maxMenuHeight="80px"
                />
                {inputSetupType && (
                    <FieldError>
                        {t("Please select a setup type")}
                    </FieldError>
                )}
            </AvGroup>
            <AvGroup>
                <StyledLabel className="mt-3 required__clz" htmlFor="text">
                    {t("Terminal Type")}
                </StyledLabel>

                <StyledSelectInput
                    data-testid="monetics-nepting-terminal-type-select"
                    className={classnames("mnt_drp_terminalType", {
                        invalid__clz: inputTerminalType,
                        readOnly__clz: isConsult,
                    })}
                    value={
                        Object.keys(typeTerminal).length > 0
                            ? typeTerminal
                            : null
                    }
                    id="typeTerminal"
                    name="typeTerminal"
                    options={typeOfTerminal}
                    onChange={(e: any) => {
                        if (e !== null) {
                            setTypeTerminal(e);
                            setInputTerminalType(false);
                        } else {
                            setInputTerminalType(true);
                        }
                        setIsEdited(true);
                    }}
                    placeholder={t("Select")}
                    noOptionsMessage={() => t("No options")}
                    maxMenuHeight="80px"
                />
                {inputTerminalType && (
                    <FieldError>
                        {t("Please select a terminal type")}
                    </FieldError>
                )}
            </AvGroup>
        </React.Fragment>
    );
}
